import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_39e83cc0 from 'nuxt_plugin_plugin_39e83cc0' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_3282eb1a from 'nuxt_plugin_recaptcha_3282eb1a' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_5426aefd from 'nuxt_plugin_vuesocialsharingplugin_5426aefd' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_workbox_9a4cbbc0 from 'nuxt_plugin_workbox_9a4cbbc0' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_61fec933 from 'nuxt_plugin_metaplugin_61fec933' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_66a66ea7 from 'nuxt_plugin_iconplugin_66a66ea7' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_vuesweetalert2_002e0a9b from 'nuxt_plugin_vuesweetalert2_002e0a9b' // Source: ./vue-sweetalert2.js (mode: 'client')
import nuxt_plugin_toast_48e8eab3 from 'nuxt_plugin_toast_48e8eab3' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_7cb89e04 from 'nuxt_plugin_axios_7cb89e04' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_gsapModule_42b411cd from 'nuxt_plugin_gsapModule_42b411cd' // Source: ./gsapModule.js (mode: 'all')
import nuxt_plugin_pluginutils_4c35ce92 from 'nuxt_plugin_pluginutils_4c35ce92' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_a9fb577c from 'nuxt_plugin_pluginrouting_a9fb577c' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_15d26326 from 'nuxt_plugin_pluginmain_15d26326' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_prototypes_13507910 from 'nuxt_plugin_prototypes_13507910' // Source: ../plugins/prototypes.js (mode: 'all')
import nuxt_plugin_alert_535fa891 from 'nuxt_plugin_alert_535fa891' // Source: ../plugins/alert.js (mode: 'client')
import nuxt_plugin_mediaLibrary_8daebfac from 'nuxt_plugin_mediaLibrary_8daebfac' // Source: ../plugins/mediaLibrary.js (mode: 'client')
import nuxt_plugin_froalaConfig_b1edbe28 from 'nuxt_plugin_froalaConfig_b1edbe28' // Source: ../plugins/froalaConfig.js (mode: 'client')
import nuxt_plugin_mapbox_80e2041c from 'nuxt_plugin_mapbox_80e2041c' // Source: ../plugins/mapbox.js (mode: 'client')
import nuxt_plugin_vuepoll_9c18c94a from 'nuxt_plugin_vuepoll_9c18c94a' // Source: ../plugins/vue-poll.js (mode: 'client')
import nuxt_plugin_coolbox_58174a1a from 'nuxt_plugin_coolbox_58174a1a' // Source: ../plugins/cool-box.js (mode: 'client')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_capitalize_64372e20 from 'nuxt_plugin_capitalize_64372e20' // Source: ../filters/capitalize.js (mode: 'all')
import nuxt_plugin_lowercase_3c566ca1 from 'nuxt_plugin_lowercase_3c566ca1' // Source: ../filters/lowercase.js (mode: 'all')
import nuxt_plugin_uppercase_6877d7e0 from 'nuxt_plugin_uppercase_6877d7e0' // Source: ../filters/uppercase.js (mode: 'all')
import nuxt_plugin_formatDate_62c134f7 from 'nuxt_plugin_formatDate_62c134f7' // Source: ../filters/formatDate.js (mode: 'all')
import nuxt_plugin_formatNumber_2b2b3bfc from 'nuxt_plugin_formatNumber_2b2b3bfc' // Source: ../filters/formatNumber.js (mode: 'all')
import nuxt_plugin_auth_7b5d3aac from 'nuxt_plugin_auth_7b5d3aac' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"custom","mode":"out-in","appear":true,"cas":false,"beforeEnter":function(el) {
    this.$gsap.set(el, {
      autoAlpha: 0,
      scale: 0.98 });
  },"enter":function(el, done) {
    this.$gsap.to(el, {
      autoAlpha: 1,
      scale: 1,
      transformOrigin: '50% 50%',
      ease: 'power2.inOut',
      onComplete: done });
  },"leave":function(el, done) {
    this.$gsap.to(el, {
      autoAlpha: 0,
      scale: 0.98,
      transformOrigin: '50% 50%',
      ease: 'power2.easeOut',
      onComplete: done });
  },"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s","title":"Primarii","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Platformă administrare conținut primării."},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Quicksand:wght@500;600;700&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Ftui-image-editor@3.2.2\u002Fdist\u002Ftui-image-editor.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fuicdn.toast.com\u002Ftui-color-picker\u002Flatest\u002Ftui-color-picker.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@5.x\u002Fcss\u002Fmaterialdesignicons.min.css"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"src":"https:\u002F\u002Fuse.fontawesome.com\u002Freleases\u002Fv5.0.8\u002Fjs\u002Fall.js","async":true},{"src":"https:\u002F\u002Fraw.githack.com\u002FeKoopmans\u002Fhtml2pdf\u002Fmaster\u002Fdist\u002Fhtml2pdf.bundle.js","async":true,"defer":true},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Ffabric.js\u002F1.6.7\u002Ffabric.min.js","async":true,"defer":true},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Ftui-code-snippet@1.4.0\u002Fdist\u002Ftui-code-snippet.min.js","async":true,"defer":true},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Ftui-image-editor@3.2.2\u002Fdist\u002Ftui-image-editor.min.js","async":true,"defer":true},{"async":true,"defer":true,"crossorigin":"anonymous","nonce":"jRPH1tqK","src":"https:\u002F\u002Fconnect.facebook.net\u002Fro_RO\u002Fsdk.js#xfbml=1&version=v11.0&appId=3000067026939796&autoLogAppEvents=1"},{"src":"https:\u002F\u002Ftranslate.google.com\u002Ftranslate_a\u002Felement.js?cb=googleTranslateElementInit2","async":true},{"src":"\u002Fjs\u002Ftranslate.js"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_39e83cc0 === 'function') {
    await nuxt_plugin_plugin_39e83cc0(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_3282eb1a === 'function') {
    await nuxt_plugin_recaptcha_3282eb1a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_5426aefd === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_5426aefd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_9a4cbbc0 === 'function') {
    await nuxt_plugin_workbox_9a4cbbc0(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_61fec933 === 'function') {
    await nuxt_plugin_metaplugin_61fec933(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_66a66ea7 === 'function') {
    await nuxt_plugin_iconplugin_66a66ea7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesweetalert2_002e0a9b === 'function') {
    await nuxt_plugin_vuesweetalert2_002e0a9b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_48e8eab3 === 'function') {
    await nuxt_plugin_toast_48e8eab3(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7cb89e04 === 'function') {
    await nuxt_plugin_axios_7cb89e04(app.context, inject)
  }

  if (typeof nuxt_plugin_gsapModule_42b411cd === 'function') {
    await nuxt_plugin_gsapModule_42b411cd(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_4c35ce92 === 'function') {
    await nuxt_plugin_pluginutils_4c35ce92(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_a9fb577c === 'function') {
    await nuxt_plugin_pluginrouting_a9fb577c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_15d26326 === 'function') {
    await nuxt_plugin_pluginmain_15d26326(app.context, inject)
  }

  if (typeof nuxt_plugin_prototypes_13507910 === 'function') {
    await nuxt_plugin_prototypes_13507910(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_alert_535fa891 === 'function') {
    await nuxt_plugin_alert_535fa891(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mediaLibrary_8daebfac === 'function') {
    await nuxt_plugin_mediaLibrary_8daebfac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_froalaConfig_b1edbe28 === 'function') {
    await nuxt_plugin_froalaConfig_b1edbe28(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mapbox_80e2041c === 'function') {
    await nuxt_plugin_mapbox_80e2041c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepoll_9c18c94a === 'function') {
    await nuxt_plugin_vuepoll_9c18c94a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_coolbox_58174a1a === 'function') {
    await nuxt_plugin_coolbox_58174a1a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_capitalize_64372e20 === 'function') {
    await nuxt_plugin_capitalize_64372e20(app.context, inject)
  }

  if (typeof nuxt_plugin_lowercase_3c566ca1 === 'function') {
    await nuxt_plugin_lowercase_3c566ca1(app.context, inject)
  }

  if (typeof nuxt_plugin_uppercase_6877d7e0 === 'function') {
    await nuxt_plugin_uppercase_6877d7e0(app.context, inject)
  }

  if (typeof nuxt_plugin_formatDate_62c134f7 === 'function') {
    await nuxt_plugin_formatDate_62c134f7(app.context, inject)
  }

  if (typeof nuxt_plugin_formatNumber_2b2b3bfc === 'function') {
    await nuxt_plugin_formatNumber_2b2b3bfc(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7b5d3aac === 'function') {
    await nuxt_plugin_auth_7b5d3aac(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
